<template>

    <div v-if="dir === 'hor'" class="form-group" :class="classes">
        <div class="form-group-info">
            <span v-if="label" class="label">{{ label }}</span>
            <span v-if="caption" v-html="caption" class="caption"></span>
        </div>
        <div class="form-group-input">
            <slot></slot>
        </div>
    </div>

    <div v-else-if="dir === 'ver'" class="form-group" :class="classes">
        <span v-if="label" class="label">{{ label }}</span>
        <slot></slot>
        <span v-if="caption" v-html="caption" class="caption"></span>
    </div>

</template>

<style scoped lang="scss">

    .form-group.form-group-hor {
        align-items: flex-start;
        border-bottom: 1px solid $color-rule;
        display: grid;
        grid-template-columns: 25% 75%;
        margin: 0;
        padding: 0;
        position: relative;
        &:last-child {
            border: none;
        }
        .form-group-info {
            border-right: 1px solid $color-bg;
            height: 100%;
            line-height: 1.2em;
            padding: 20px 30px;
            .label {
                @include font-semibold(13px);
                color: $color-text;
                display: block;
            }
            .caption {
                @include font-medium(13px);
                color: $color-muted;
                display: block;
                margin-top: 5px;
            }
        }
        .form-group-input {
            padding: 20px 30px;
            p {
                @include font-medium(13px);
                line-height: 1.6em;
            }
            ul, ol {
                @include font-medium(13px);
                line-height: 1.6em;
                margin: 0;
                padding: 0;
                list-style: none;
            }
        }
    }

    .form-group.form-group-ver {
        margin: 0 0 20px 0;
        padding: 0;
        .label {
            @include font-semibold(13px);
            color: $color-text;
            display: block;
            line-height: normal;
            margin-bottom: 10px;
        }
        .caption {
            @include font-medium(13px);
            color: $color-muted;
            display: block;
            margin-top: 10px;
        }
    }

</style>

<script>

export default {

    props: {
        label: {
            type: String,
        },
        caption: {
            type: String,
        },
        dir: {
            type: String,
            default: 'hor',
        },
    },

    computed: {

        classes() {
            return {
                'form-group-ver': this.dir === 'ver',
                'form-group-hor': this.dir === 'hor',
            }
        },

    },

}

</script>
